import { Flex, Image, Text, Button, Box, Link } from "@chakra-ui/react";
import {
  RiBook2Line,
  RiChat3Line,
  RiDashboardLine,
  RiHomeLine,
  RiMap2Line,
} from "react-icons/ri";
import React from "react";

const LinkItem = ({ icon, title, active, url }) => {
  return (
    <Flex
      as={url ? Link : "div"}
      href={url}
      direction={"column"}
      position="relative"
      cursor={"pointer"}
      userSelect={"none"}
    >
      <Text
        fontSize="16px"
        lineHeight={"200%"}
        fontWeight={active ? "600" : "400"}
        display={{ base: "none", md: "block" }}
      >
        {title}
      </Text>
      <Box display={{ base: "block", md: "none" }}>
        {React.createElement(icon, { size: 30, color: "#fff" })}
      </Box>
      {active && (
        <Box
          width={"100%"}
          overflow={"hidden"}
          height={"2px"}
          backgroundColor={"#fff"}
          borderRadius={"2px"}
          position="absolute"
          bottom={"-30px"}
        />
      )}
    </Flex>
  );
};

const Component = () => {
  return (
    <Flex
      direction="row"
      padding="24px 0px"
      justifyContent={"space-between"}
      alignItems={"center"}
      width={"100%"}
      borderBottom={"1px solid rgba(255, 255, 255, 0.10)"}
    >
      <Flex direction={"row"} gap={"12px"}>
        <Image src="/logo.svg" alt="Logo" width="40px" height="40px" />
        <Text
          fontSize="24px"
          fontWeight={"600"}
          display={{ base: "none", md: "block" }}
        >
          socialproject.pl
        </Text>
      </Flex>
      <Flex direction={"row"} gap={"40px"}>
        <LinkItem icon={RiHomeLine} title={"Strona główna"} active />
        <LinkItem icon={RiDashboardLine} title={"Panel gracza"} />
        <LinkItem icon={RiChat3Line} title={"Forum"} url="https://forum.socialproject.pl" />
        <LinkItem icon={RiBook2Line} title={"Wikipedia"} />
        <LinkItem icon={RiMap2Line} title={"Mapa"} />
      </Flex>
      <Button
        fontWeight={"400"}
        fontSize={"14px"}
        display={{ base: "none", md: "block" }}
        as={Link}
        href="https://discord.socialproject.pl"
        target="_blank"
        height="40px"
        lineHeight="40px"
        style={{ textDecoration: "none" }}
        backgroundColor={"#fff"}
        color={"#000"}
        _hover={{ backgroundColor: "#d6d6d6" }}
      >
        Dołącz do nas
      </Button>
    </Flex>
  );
};

export default Component;
